var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 350,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 345,
    r: 5,
    transform: "rotate(-90 5 345)",
    fill: "#FBBF24"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 325,
    r: 5,
    transform: "rotate(-90 5 325)",
    fill: "#FBBF24"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 305,
    r: 5,
    transform: "rotate(-90 5 305)",
    fill: "#FBBF24"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 285,
    r: 5,
    transform: "rotate(-90 5 285)",
    fill: "#FBBF24"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 265,
    r: 5,
    transform: "rotate(-90 5 265)",
    fill: "#FBBF24"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 245,
    r: 5,
    transform: "rotate(-90 5 245)",
    fill: "#FBBF24"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 225,
    r: 5,
    transform: "rotate(-90 5 225)",
    fill: "#FBBF24"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 205,
    r: 5,
    transform: "rotate(-90 5 205)",
    fill: "#FBBF24"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 185,
    r: 5,
    transform: "rotate(-90 5 185)",
    fill: "#FBBF24"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 165,
    r: 5,
    transform: "rotate(-90 5 165)",
    fill: "#FBBF24"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 145,
    r: 5,
    transform: "rotate(-90 5 145)",
    fill: "#FBBF24"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 125,
    r: 5,
    transform: "rotate(-90 5 125)",
    fill: "#FBBF24"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 105,
    r: 5,
    transform: "rotate(-90 5 105)",
    fill: "#FBBF24"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 85,
    r: 5,
    transform: "rotate(-90 5 85)",
    fill: "#FBBF24"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 65,
    r: 5,
    transform: "rotate(-90 5 65)",
    fill: "#FBBF24"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 45,
    r: 5,
    transform: "rotate(-90 5 45)",
    fill: "#FBBF24"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 25,
    r: 5,
    transform: "rotate(-90 5 25)",
    fill: "#FBBF24"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "rotate(-90 5 5)",
    fill: "#FBBF24"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 345,
    r: 5,
    transform: "rotate(-90 25 345)",
    fill: "#FBBF24"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 325,
    r: 5,
    transform: "rotate(-90 25 325)",
    fill: "#FBBF24"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 305,
    r: 5,
    transform: "rotate(-90 25 305)",
    fill: "#FBBF24"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 285,
    r: 5,
    transform: "rotate(-90 25 285)",
    fill: "#FBBF24"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 265,
    r: 5,
    transform: "rotate(-90 25 265)",
    fill: "#FBBF24"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 245,
    r: 5,
    transform: "rotate(-90 25 245)",
    fill: "#FBBF24"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 225,
    r: 5,
    transform: "rotate(-90 25 225)",
    fill: "#FBBF24"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 205,
    r: 5,
    transform: "rotate(-90 25 205)",
    fill: "#FBBF24"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 185,
    r: 5,
    transform: "rotate(-90 25 185)",
    fill: "#FBBF24"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 165,
    r: 5,
    transform: "rotate(-90 25 165)",
    fill: "#FBBF24"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 145,
    r: 5,
    transform: "rotate(-90 25 145)",
    fill: "#FBBF24"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 125,
    r: 5,
    transform: "rotate(-90 25 125)",
    fill: "#FBBF24"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 105,
    r: 5,
    transform: "rotate(-90 25 105)",
    fill: "#FBBF24"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 85,
    r: 5,
    transform: "rotate(-90 25 85)",
    fill: "#FBBF24"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 65,
    r: 5,
    transform: "rotate(-90 25 65)",
    fill: "#FBBF24"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 45,
    r: 5,
    transform: "rotate(-90 25 45)",
    fill: "#FBBF24"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 5,
    transform: "rotate(-90 25 25)",
    fill: "#FBBF24"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 5,
    r: 5,
    transform: "rotate(-90 25 5)",
    fill: "#FBBF24"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 345,
    r: 5,
    transform: "rotate(-90 45 345)",
    fill: "#FBBF24"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 325,
    r: 5,
    transform: "rotate(-90 45 325)",
    fill: "#FBBF24"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 305,
    r: 5,
    transform: "rotate(-90 45 305)",
    fill: "#FBBF24"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 285,
    r: 5,
    transform: "rotate(-90 45 285)",
    fill: "#FBBF24"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 265,
    r: 5,
    transform: "rotate(-90 45 265)",
    fill: "#FBBF24"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 245,
    r: 5,
    transform: "rotate(-90 45 245)",
    fill: "#FBBF24"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 225,
    r: 5,
    transform: "rotate(-90 45 225)",
    fill: "#FBBF24"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 205,
    r: 5,
    transform: "rotate(-90 45 205)",
    fill: "#FBBF24"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 185,
    r: 5,
    transform: "rotate(-90 45 185)",
    fill: "#FBBF24"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 165,
    r: 5,
    transform: "rotate(-90 45 165)",
    fill: "#FBBF24"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 145,
    r: 5,
    transform: "rotate(-90 45 145)",
    fill: "#FBBF24"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 125,
    r: 5,
    transform: "rotate(-90 45 125)",
    fill: "#FBBF24"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 105,
    r: 5,
    transform: "rotate(-90 45 105)",
    fill: "#FBBF24"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 85,
    r: 5,
    transform: "rotate(-90 45 85)",
    fill: "#FBBF24"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 65,
    r: 5,
    transform: "rotate(-90 45 65)",
    fill: "#FBBF24"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 5,
    transform: "rotate(-90 45 45)",
    fill: "#FBBF24"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 25,
    r: 5,
    transform: "rotate(-90 45 25)",
    fill: "#FBBF24"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 5,
    r: 5,
    transform: "rotate(-90 45 5)",
    fill: "#FBBF24"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 345,
    r: 5,
    transform: "rotate(-90 65 345)",
    fill: "#FBBF24"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 325,
    r: 5,
    transform: "rotate(-90 65 325)",
    fill: "#FBBF24"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 305,
    r: 5,
    transform: "rotate(-90 65 305)",
    fill: "#FBBF24"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 285,
    r: 5,
    transform: "rotate(-90 65 285)",
    fill: "#FBBF24"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 265,
    r: 5,
    transform: "rotate(-90 65 265)",
    fill: "#FBBF24"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 245,
    r: 5,
    transform: "rotate(-90 65 245)",
    fill: "#FBBF24"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 225,
    r: 5,
    transform: "rotate(-90 65 225)",
    fill: "#FBBF24"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 205,
    r: 5,
    transform: "rotate(-90 65 205)",
    fill: "#FBBF24"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 185,
    r: 5,
    transform: "rotate(-90 65 185)",
    fill: "#FBBF24"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 165,
    r: 5,
    transform: "rotate(-90 65 165)",
    fill: "#FBBF24"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 145,
    r: 5,
    transform: "rotate(-90 65 145)",
    fill: "#FBBF24"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 125,
    r: 5,
    transform: "rotate(-90 65 125)",
    fill: "#FBBF24"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 105,
    r: 5,
    transform: "rotate(-90 65 105)",
    fill: "#FBBF24"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 85,
    r: 5,
    transform: "rotate(-90 65 85)",
    fill: "#FBBF24"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 5,
    transform: "rotate(-90 65 65)",
    fill: "#FBBF24"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 45,
    r: 5,
    transform: "rotate(-90 65 45)",
    fill: "#FBBF24"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 25,
    r: 5,
    transform: "rotate(-90 65 25)",
    fill: "#FBBF24"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 5,
    r: 5,
    transform: "rotate(-90 65 5)",
    fill: "#FBBF24"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 345,
    r: 5,
    transform: "rotate(-90 85 345)",
    fill: "#FBBF24"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 325,
    r: 5,
    transform: "rotate(-90 85 325)",
    fill: "#FBBF24"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 305,
    r: 5,
    transform: "rotate(-90 85 305)",
    fill: "#FBBF24"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 285,
    r: 5,
    transform: "rotate(-90 85 285)",
    fill: "#FBBF24"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 265,
    r: 5,
    transform: "rotate(-90 85 265)",
    fill: "#FBBF24"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 245,
    r: 5,
    transform: "rotate(-90 85 245)",
    fill: "#FBBF24"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 225,
    r: 5,
    transform: "rotate(-90 85 225)",
    fill: "#FBBF24"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 205,
    r: 5,
    transform: "rotate(-90 85 205)",
    fill: "#FBBF24"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 185,
    r: 5,
    transform: "rotate(-90 85 185)",
    fill: "#FBBF24"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 165,
    r: 5,
    transform: "rotate(-90 85 165)",
    fill: "#FBBF24"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 145,
    r: 5,
    transform: "rotate(-90 85 145)",
    fill: "#FBBF24"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 125,
    r: 5,
    transform: "rotate(-90 85 125)",
    fill: "#FBBF24"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 105,
    r: 5,
    transform: "rotate(-90 85 105)",
    fill: "#FBBF24"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 5,
    transform: "rotate(-90 85 85)",
    fill: "#FBBF24"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 65,
    r: 5,
    transform: "rotate(-90 85 65)",
    fill: "#FBBF24"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 45,
    r: 5,
    transform: "rotate(-90 85 45)",
    fill: "#FBBF24"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 25,
    r: 5,
    transform: "rotate(-90 85 25)",
    fill: "#FBBF24"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 5,
    r: 5,
    transform: "rotate(-90 85 5)",
    fill: "#FBBF24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.56a416450b25edba8867adca99bfac21.svg";
export { ForwardRef as ReactComponent };